import React from "react";
import { UserTable } from "../../components/datatable/userDatatable";

const Users = () => {
  return <UserTable />;
};

export default Users;
